module.exports = __webpack_public_path__ + "img/banklogo-4.a99c8e47.png";